import { useEffect, useRef, useCallback } from 'react';
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || '';

export function useSocket() {
  const socketRef = useRef(null);
  const reconnectCallbackRef = useRef(null);
  // Отдельный callback для возврата на вкладку (без join_room — сокет жив)
  const onVisibleCallbackRef = useRef(null);

  useEffect(() => {
    socketRef.current = io(SOCKET_URL, {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 800,
      reconnectionDelayMax: 2500,
      timeout: 15000,
      autoConnect: true,
    });

    const socket = socketRef.current;

    const handleConnect = () => {
      console.log(`[socket] connected (id: ${socket.id})`);
      reconnectCallbackRef.current?.();
    };

    const handleReconnect = () => {
      console.log(`[socket] reconnected (id: ${socket.id})`);
      reconnectCallbackRef.current?.();
    };

    const handleDisconnect = (reason) => {
      console.log(`[socket] disconnected: ${reason}`);
    };

    const handleConnectError = (err) => {
      console.log('[socket] connect_error:', err.message);
    };

    socket.on('connect', handleConnect);
    socket.on('reconnect', handleReconnect);
    socket.on('disconnect', handleDisconnect);
    socket.on('connect_error', handleConnectError);

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return;
      console.log('[socket] tab became visible');
      if (socket.connected) {

      } else {
        console.log('[socket] was disconnected → reconnecting...');
        socket.connect();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    const healthCheckInterval = setInterval(() => {
      if (document.visibilityState === 'visible' && socket && !socket.connected) {
        console.log('[socket] health check: reconnecting');
        socket.connect();
      }
    }, 10000);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      clearInterval(healthCheckInterval);
      
      socket.off('connect', handleConnect);
      socket.off('reconnect', handleReconnect);
      socket.off('disconnect', handleDisconnect);
      socket.off('connect_error', handleConnectError);
      
      socket.disconnect();
      socketRef.current = null;
    };
  }, []);

  const emit = useCallback((event, data) => {
    if (socketRef.current?.connected) {
      socketRef.current.emit(event, data);
    } else {
      console.warn(`[socket] emit ${event} skipped - not connected`);
    }
  }, []);

  const on = useCallback((event, handler) => {
    const socket = socketRef.current;
    if (!socket) return () => {};
    socket.off(event, handler);
    socket.on(event, handler);
    return () => socket.off(event, handler);
  }, []);

  const off = useCallback((event, handler) => {
    socketRef.current?.off(event, handler);
  }, []);

  const onReconnect = useCallback((callback) => {
    reconnectCallbackRef.current = callback;
  }, []);

  const onVisible = useCallback((callback) => {
    onVisibleCallbackRef.current = callback;
  }, []);

  return {
    socketRef,
    emit,
    on,
    off,
    onReconnect,
    onVisible,
  };
}